/* ==========================================================================
   Jardin Flamingo — header behaviour. Native JS, no dependencies.
   Every binding is guarded so repeated init (Theme Editor section reloads)
   cannot stack duplicate listeners.
   ========================================================================== */
(function () {
  var FOCUSABLE = 'a[href], button:not([disabled]), input, select, textarea, [tabindex]:not([tabindex="-1"])';
  var openCount = 0; // how many overlays are currently open

  function lockScroll() {
    openCount += 1;
    document.body.style.overflow = 'hidden';
  }
  function unlockScroll() {
    openCount = Math.max(0, openCount - 1);
    // Only restore scrolling once every overlay is closed.
    if (openCount === 0) document.body.style.overflow = '';
  }

  function trap(panel, e) {
    if (e.key !== 'Tab' || !panel) return;
    var nodes = Array.prototype.filter.call(panel.querySelectorAll(FOCUSABLE), function (n) {
      return n.offsetParent !== null;
    });
    if (!nodes.length) return;
    var first = nodes[0];
    var last = nodes[nodes.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  function Overlay(root, opener) {
    if (!root || !opener) return;
    if (root.dataset.jfBound === 'true') return; // guard: no duplicate listeners
    root.dataset.jfBound = 'true';

    var panel = root.querySelector('[data-panel]');
    var lastFocus = null;

    function open() {
      if (root.dataset.open === 'true') return;
      lastFocus = document.activeElement;
      root.dataset.open = 'true';
      opener.setAttribute('aria-expanded', 'true');
      lockScroll();
      var f = panel && panel.querySelector(FOCUSABLE);
      if (f) setTimeout(function () { f.focus(); }, 60);
    }

    function close() {
      if (root.dataset.open !== 'true') return;
      root.dataset.open = 'false';
      opener.setAttribute('aria-expanded', 'false');
      unlockScroll();
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    opener.addEventListener('click', function () {
      root.dataset.open === 'true' ? close() : open();
    });

    root.querySelectorAll('[data-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      trap(panel, e);
    });

    root._jfClose = close;
  }

  function initHeaderScroll() {
    var header = document.querySelector('[data-jf-header]');
    if (!header || header.dataset.jfScrollBound === 'true') return;
    header.dataset.jfScrollBound = 'true';
    var onScroll = function () {
      header.dataset.scrolled = window.scrollY > 8 ? 'true' : 'false';
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initSubToggles() {
    document.querySelectorAll('[data-jf-subtoggle]').forEach(function (btn) {
      if (btn.dataset.jfBound === 'true') return;
      btn.dataset.jfBound = 'true';
      btn.addEventListener('click', function () {
        var sub = document.getElementById(btn.getAttribute('aria-controls'));
        if (!sub) return;
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        sub.dataset.open = String(!isOpen);
      });
    });
  }

  function initMega() {
    document.querySelectorAll('[data-jf-mega-toggle]').forEach(function (btn) {
      if (btn.dataset.jfBound === 'true') return;
      btn.dataset.jfBound = 'true';

      var mega = document.getElementById(btn.getAttribute('aria-controls'));
      var item = btn.closest('.jf-nav__item');
      if (!mega || !item) return;

      function closeMega() {
        btn.setAttribute('aria-expanded', 'false');
        mega.dataset.open = 'false';
      }

      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!isOpen));
        mega.dataset.open = String(!isOpen);
      });

      item.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { closeMega(); btn.focus(); }
      });

      // One document listener per toggle, added once thanks to the guard above.
      document.addEventListener('click', function (e) {
        if (!item.contains(e.target)) closeMega();
      });
    });
  }

  function init() {
    initHeaderScroll();
    Overlay(document.querySelector('[data-jf-mnav]'), document.querySelector('[data-jf-burger]'));
    Overlay(document.querySelector('[data-jf-search]'), document.querySelector('[data-jf-search-open]'));
    initSubToggles();
    initMega();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme Editor re-renders the header section; re-init is safe due to guards.
  document.addEventListener('shopify:section:load', function () {
    document.body.style.overflow = '';
    openCount = 0;
    init();
  });
})();
